import { normalizeLabel } from '../../utils/normalizeLabel';
import MinusSVG from '../../assets/imgs/icon/Minus.svg';
import PlusSVG from '../../assets/imgs/icon/Plus.svg';
import './styles.css';

export type QuantityControlProps = {
	quantity: string | number;
	increment: React.MouseEventHandler<HTMLDivElement>;
	decrement: React.MouseEventHandler<HTMLDivElement>;
	name?: string;
	margins?: number;
	internalPadding?: number;
	color?: string;
	size?: string;
	fontColor?: string;
};

export const QuantityControl: React.FC<QuantityControlProps> = ({
	quantity,
	increment,
	decrement,
	name,
	internalPadding = 3,
	color = 'dark',
	size = 'medium',
	fontColor = 'white'
}) => {
	name = name ? normalizeLabel(name) : undefined;

	return (
		<div
			className={`quantity-element w-100 d-flex align-items-center justify-content-between quantity-control quantity-control-${size}`}
			style={{}}
		>
			<div
				onClick={decrement}
				style={{ width: '24px', height: '24px', cursor: 'pointer' }}
			>
				<img src={MinusSVG} style={{ width: '24px' }} />
			</div>

			<p className={`mb-0 flex-fill px-${internalPadding}`}>
				<span
					className={`badge px-2 py-2 w-100 badge-${color} text-${fontColor}`}
					style={{ borderRadius: '4px', fontSize: '16px' }}
				>
					{quantity}
				</span>
			</p>

			<div
				style={{ width: '24px', height: '24px', cursor: 'pointer' }}
				onClick={increment}
			>
				<img src={PlusSVG} style={{ width: '24px' }} />
			</div>
		</div>
	);
};
